/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeRTSStep3chPage() {
  customValidationInit(true);
  aspControlValidationInit();
}
